import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import CategoryGrid from "./components/CategoryGrid";
import LatestAnime from "./components/LatestAnime";
import NewsPreview from "./components/NewsPreview";
import SearchBar from "@/components/feature/SearchBar";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const hotTags = ["热血", "治愈", "科幻", "恋爱", "悬疑", "奇幻"];

export default function Home() {
  useDocumentTitle(
    "动漫网站-精选动漫全集与最新动画资讯平台",
    "动漫网站致力于提供丰富的动漫资源和最新的动画新闻，覆盖热门动画片和经典动漫，让用户轻松在线观看和了解动漫动态。"
  );

  return (
    <div className="w-full">
      <div className="relative">
        <HeroCarousel />
        <div className="relative z-20 mx-auto max-w-[1280px] px-4 md:px-8 -mt-12 md:-mt-16">
          <div className="rounded-lg bg-background-50 border border-background-200/70 p-4 md:p-5">
            <h1 className="font-heading font-bold text-lg md:text-2xl text-foreground-950 text-center mb-4">
              精选动漫全集 · 最新动画资讯平台
            </h1>
            <div className="max-w-3xl mx-auto">
              <SearchBar size="lg" />
            </div>
            <div className="flex items-center justify-center flex-wrap gap-2 mt-4">
              <span className="text-xs text-foreground-400">热门搜索：</span>
              {hotTags.map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag)}`}
                  className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs hover:bg-primary-50 hover:text-primary-600 transition-colors"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CategoryGrid />
      <LatestAnime />
      <NewsPreview />
    </div>
  );
}